import { ApiError, UNAVAILABLE_MESSAGE, apiErrorFromResponse, resolveApiUrl } from './http';

const WRONG_PASSWORD_MESSAGE = 'Forkert adgangskode. Prøv igen.';
const ADMIN_DISABLED_MESSAGE = 'Læreradgang er ikke aktiveret på serveren.';

function isAbortError(error: unknown): boolean {
  return (
    (error instanceof DOMException && error.name === 'AbortError')
    || (error instanceof Error && error.name === 'AbortError')
  );
}

export async function validateAdminToken(token: string, signal?: AbortSignal): Promise<void> {
  let response: Response;
  try {
    response = await fetch(resolveApiUrl('/chat/admin/auth/session'), {
      method: 'GET',
      cache: 'no-store',
      signal,
      headers: {
        Accept: 'application/json',
        'X-Admin-Token': token,
      },
    });
  } catch (error) {
    if (signal?.aborted || isAbortError(error)) {
      throw error instanceof Error ? error : new DOMException('Aborted', 'AbortError');
    }
    throw new ApiError({
      httpStatus: 0,
      code: null,
      userMessage: UNAVAILABLE_MESSAGE,
    });
  }

  if (response.status === 204) {
    return;
  }

  if (response.status === 401) {
    throw new ApiError({
      httpStatus: 401,
      code: null,
      userMessage: WRONG_PASSWORD_MESSAGE,
    });
  }

  if (response.status === 404) {
    throw new ApiError({
      httpStatus: 404,
      code: 'not_found',
      userMessage: ADMIN_DISABLED_MESSAGE,
    });
  }

  throw await apiErrorFromResponse(response);
}
